var appController = require('service/app-controller');

    require('service/keyboard').init();
    require('service/global-var');
    module.exports = {
        el:function () {
            return "body";
        },
        data:function () {
            return {
                apps:appController.apps,
                files:appController.files
            }
        },
        replace: false,
        components:{
            wallpaper:require('views/wallpaper.vue'),
            files:require('views/file.vue'),
            selection:require('views/selection.vue'),
            application:require('views/application.vue'),
            taskbar:require('views/taskbar.vue'),
            mousemenu:require('views/mouse-menu.vue')
        },
        ready:function () {
            var vm = this;
        }
    };


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/root.vue
 ** module id = 31
 ** module chunks = 0
 **/